import { types } from 'mobx-state-tree'

const StateModel = types.model('StateModel').props({
  title: types.optional(types.string, `I'm a new Page title`),
  size: types.optional(types.number, 40),
})

const StyleModel = types.model('StyleModel').props({
  width: types.string,
  height: types.string,
  color: types.string,
  border: types.string,
  padding: types.string,
})

const PropsModel = types.model('PropsModel').props({
  headerModel: types.maybeNull(StateModel),
  styleModel: types.maybeNull(StyleModel),
})

const BlockModel = types.model('BlockModel').props({
  blockID: types.optional(types.string, ''),
  compID: types.optional(types.string, ''),
  position: types.optional(types.number, 0),
  content: types.maybe(types.string),
  id: types.maybeNull(types.number),
  blockId: types.maybeNull(types.number),
})

export const ContentModel = types
  .model('ContentModel')
  .props({
    blocks: types.array(BlockModel),
  })
  .actions((self: any) => {
    const insert = (block: any) => {
      self.blocks.push(block)
    }

    const update = ({ index, block }: any) => {
      self.blocks[index] = block
    }

    return {
      insert,
      update,
    }
  })

const HeaderInterface = types.model('HeaderInterface', {
  name: types.optional(types.string, ''),
  input: types.optional(
    types.model({
      type: types.optional(types.string, ''),
      model: types.optional(PropsModel, {} as any),
    }),
    {} as any
  ),
})

export const PropsInterface = types.model('Interface', {
  blockID: types.optional(types.string, ''),
  interface: types.optional(types.array(HeaderInterface), [] as any),
  state: types.optional(StateModel, {} as any),
})
